import { classnames } from '@/helpers';
import { twMerge } from 'tailwind-merge';

export type HeaderProps = {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  label?: string;
  h?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  fontWeight?: '400' | '500' | '600' | '700';
  wrapperElement?: 'header' | 'div' | 'section';
};

// TODO
// These SIZE Class need to be sorted out since the md prop uses the text-md class which is not a header class.
// The rest of the classes are header classes.
const SIZE_CLASSES = {
  xs: 'text-h-xxs',
  sm: 'text-h-xs',
  md: 'text-md',
  lg: 'text-h-s',
  xl: 'text-h-m',
};

const FONT_WEIGHT_CLASSES = {
  '400': 'font-regular',
  '500': 'font-medium',
  '600': 'font-semibold',
  '700': 'font-bold',
};

const Header = ({
  leftIcon,
  rightIcon,
  children,
  label,
  className,
  size,
  fontWeight = '600',
  h = 'span',
  wrapperElement = 'div',
}: HeaderProps) => {
  const Tag = h as keyof JSX.IntrinsicElements;

  const getContent = (
    <>
      {leftIcon && <span>{leftIcon}</span>}
      <Tag
        className={twMerge(
          classnames('text-black-900 flex-1', FONT_WEIGHT_CLASSES[fontWeight], SIZE_CLASSES[size]),
          className,
        )}>
        {label ?? children}
      </Tag>
      {rightIcon && <span>{rightIcon}</span>}
    </>
  );

  switch (wrapperElement) {
    case 'div':
      return <div className="space-x-md inline-flex w-full">{getContent}</div>;
    case 'header':
      return <header className="space-x-md inline-flex w-full">{getContent}</header>;
    case 'section':
      return <section className="space-x-md inline-flex w-full">{getContent}</section>;
    default:
      return <div className="space-x-md inline-flex w-full">{getContent}</div>;
  }
};

export default Header;
